/* eslint-disable no-unused-vars */
/**
 * This file is part of "Zona franca"
 * Copyright (c) 2022
 * Zona franca
 * All rights reserved
 *
 * @author Turiano Romero <https://bitbucket.org/rome9603/ | tromero@technisupport.com>
 * @version 2.0
 */

import {
  applyMiddleware,
  combineReducers,
  compose,
  legacy_createStore as createStore,
} from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import thunk from "redux-thunk";
// import rootSaga from "../sagas";
import { authenticationReducer, customsClearanceReducer } from "redux/reducer";
import { FormsUploadIntReducer } from "redux/reducer/FormsReducer";
import { currentFormReducer } from "redux/reducer/currentFormReducer";
import { firstLoginReducer } from "redux/reducer/firstLoginReducer";
import permissionsReducer from "redux/reducer/permissionsReducer";
import { searchReducer } from "redux/reducer/searchReducer";
import { securityReducer } from "redux/reducer/securityReducer";
import { statusBalanceReducer } from "redux/reducer/statusBalanceReducer";
import { statusFreeZoneReducer } from "redux/reducer/statusFreeZone";
import { statusTrmReducer } from "redux/reducer/statusTrmReducer";
import formReducer from "redux/reducer/useFormReducer";
import { UserReducer } from "redux/reducer/userReducer";

// configure redux devtools
const composeEnhancers =
  (typeof window !== "undefined" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

// const storeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistConfig = {
  key: "root",
  storage,
};

const persistForm = {
  key: "form",
  storage,
};

const persistSearch = {
  key: "search",
  storage,
};

// combine reducers
const reducers = combineReducers({
  permissions: permissionsReducer,
  security: securityReducer,
  FormsInt: FormsUploadIntReducer,
  CurrentForm: persistReducer(persistForm, currentFormReducer),
  customsClearanceState: customsClearanceReducer,
  auth: persistReducer(persistConfig, authenticationReducer),
  search: searchReducer,
  status: statusBalanceReducer,
  statusTrm: statusTrmReducer,
  form: formReducer,
  chagenFreeZone: statusFreeZoneReducer,
  userInfo: UserReducer,
  firstLogin: persistReducer({ storage, key: "firstLogin" }, firstLoginReducer),
  // customsClearanceState: persistReducer(persistConfig, customsClearanceReducer),
});

let store = createStore(reducers, composeEnhancers(applyMiddleware(thunk)));
let persistor = persistStore(store);
export { store, persistor };

// export default () => {
//   let store = createStore(reducers, composeEnhancers());
//   let persistor = persistStore(store);
//   return { store, persistor };
// };
